<div class="success-container">
    <img src="/assets/images/Tick.svg" alt="">
    <h1 mat-dialog-title>Congratulations!</h1>
    <div mat-dialog-content>
        <p> Your account is ready to use. You will be redirected to the login page in a few seconds..</p>
    <div class="spinner-container loader-align">
        <span class="spinner"></span>
    </div>
</div>    
</div>